import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router';
import styled from 'styled-components';

import NavigationStep from './NavigationStep';

type Props = {
  className?: string;
};

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Step = styled(NavigationStep)`
  flex: 0 0 auto;

  width: 400px;
`;

const Separator = styled.div.attrs({ role: 'presentation' })`
  flex: 1 1 auto;
  border-block-start: 1px dashed ${cssThemedValue('borderPrimary')};
  padding-block-end: 28px;
  max-width: 80px;
`;

const Navigation = ({ className }: Props) => {
  const { url } = useRouteMatch();
  const intl = useIntl();
  return (
    <Root className={className}>
      <Step
        num={1}
        label={intl.formatMessage({ id: 'venue-data-collection.venue-information-form.general' })}
        to={`${url}/general`}
      />
      <Separator />
      <Step
        num={2}
        label={intl.formatMessage({ id: 'venue-data-collection.venue-information-form.opening-hours' })}
        to={`${url}/opening-hours`}
      />
      <Separator />
      <Step
        num={3}
        label={intl.formatMessage({ id: 'venue-data-collection.venue-information-form.confirm' })}
        to={`${url}/confirm`}
      />
    </Root>
  );
};

export default Navigation;
